





export function sanitizeSSOParams(s: string): string {
    return s.replace(/((Token|Expiration|Identity|Roles)=[^&]+[&]?)/g, "").replace(/[&?]$/, "");
}
